export default {
    intro: 'Fill in the blanks to complete the table!',
};
